import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Occurrences from "@/pages/Occurrences";
import Expenses from "@/pages/Expenses";
import ExpenseForm from "@/pages/ExpenseForm";
import OrdinaryExpenses from "@/pages/OrdinaryExpenses";
import Receivables from "@/pages/Receivables";
import RecurringReceivables from "@/pages/RecurringReceivables";
import DailyReceipts from "@/pages/DailyReceipts";
import ReceivableForm from "@/pages/ReceivableForm";
import Forecast from "@/pages/Forecast";
import Variance from "@/pages/Variance";
import Analytics from "@/pages/Analytics";
import Reconciliation from "@/pages/Reconciliation";
import PrimaNota from "@/pages/PrimaNota";
import Settings from "@/pages/Settings";

function ProtectedShell() {
  const { status } = useAuth();
  if (status === "loading") {
    return (
      <div
        data-testid="auth-loading"
        className="flex min-h-screen items-center justify-center text-sm text-stone-500"
      >
        Verifica sessione…
      </div>
    );
  }
  if (status !== "authenticated") return <Navigate to="/login" replace />;
  return <Layout />;
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedShell />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/occurrences" element={<Occurrences />} />
              <Route path="/expenses" element={<Expenses />} />
              <Route path="/expenses/new" element={<ExpenseForm />} />
              <Route path="/expenses/:id/edit" element={<ExpenseForm />} />
              <Route path="/ordinary" element={<OrdinaryExpenses />} />
              <Route path="/ordinary/new" element={<ExpenseForm />} />
              <Route path="/ordinary/:id/edit" element={<ExpenseForm />} />
              <Route path="/receivables" element={<Receivables />} />
              <Route path="/receivables/recurring" element={<RecurringReceivables />} />
              {/* Legacy `/receivables/ordinary` list page deprecated: ordinary
                  receivables are now registered through the Prima Nota at
                  `/receivables/daily`. Existing /receivables/ordinary/:id/edit
                  routes (and /new) stay live for backwards-compat with any
                  already-created one_time receivable. */}
              <Route path="/receivables/ordinary" element={<Navigate to="/receivables/daily" replace />} />
              <Route path="/receivables/new" element={<ReceivableForm />} />
              <Route path="/receivables/:id/edit" element={<ReceivableForm />} />
              <Route path="/receivables/ordinary/new" element={<ReceivableForm />} />
              <Route path="/receivables/ordinary/:id/edit" element={<ReceivableForm />} />
              <Route path="/receivables/daily" element={<DailyReceipts />} />
              <Route path="/prima-nota" element={<PrimaNota />} />
              <Route path="/forecast" element={<Forecast />} />
              <Route path="/variance" element={<Variance />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/reconciliation" element={<Reconciliation />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
          <Toaster
            position="top-right"
            richColors
            toastOptions={{ duration: 3500 }}
          />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
